export default __webpack_public_path__ + "static/media/icn4.28b34556.PNG";